export const blogActions = {
  GET_POSTS_PENDING: 'GET_POSTS_PENDING',
  GET_POSTS_SUCCESS: 'GET_POSTS_SUCCESS',
  GET_POSTS_ERROR: 'GET_POSTS_ERROR',

};
